import React from 'react'
import { useState } from 'react';
import {
    Row,
    Col,
    Button,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Modal,
  } from "reactstrap";
  const ErrorModal = ({ isOpen, toggle, errorMessage }) => {
    return (
      <div>
      <Modal isOpen={isOpen} toggle={toggle} 
      backdrop="static"
      centered={true}
      size='md'
      >
        <ModalHeader toggle={toggle} className="custom_header_colour align-items-center"><h3 className='mb-0 ' style={{ fontSize: '20px' }}>Server Alert</h3></ModalHeader>
        <ModalBody>
          
            <p className="card-just-text"  style ={{fontSize:"20px"}}>
            The Server is on Maintaince 
            </p>
            
        </ModalBody>
        <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
      </div>
    );
  };
  
  export default ErrorModal;